"use client";

// src/components/coloured/google-login-coloured.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var GoogleLoginColouredIcon = systemForwardRef(function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
  const identifier = useUID();
  const titleId = title ? `GoogleLoginColouredIcon-${id != null ? id : identifier}` : void 0;
  const role = title ? "img" : "presentation";
  const componentName = `GoogleLoginColouredIcon`;
  return /* @__PURE__ */ React.createElement(
    IconContainer,
    {
      ...rest,
      display,
      size,
      color,
      ref
    },
    /* @__PURE__ */ React.createElement(
      "svg",
      {
        "data-genesis-element": componentName,
        role,
        width: "100%",
        height: "100%",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": titleId
      },
      title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.68 8.18177C15.68 7.6145 15.6291 7.06905 15.5345 6.54541H8V9.63995H12.3054C12.12 10.64 11.5564 11.4872 10.7091 12.0545V14.0618H13.2945C14.8073 12.669 15.68 10.6181 15.68 8.18177Z",
          fill: "#4285F4"
        }
      ),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99991 16C10.1599 16 11.9708 15.2836 13.2945 14.0618L10.709 12.0546C9.99264 12.5346 9.07627 12.8182 7.99991 12.8182C5.91628 12.8182 4.15264 11.4109 3.52355 9.52002H0.85083V11.5927C2.16719 14.2073 4.87264 16 7.99991 16Z",
          fill: "#34A853"
        }
      ),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.52363 9.51995C3.36363 9.03995 3.27272 8.52722 3.27272 7.99995C3.27272 7.47268 3.36363 6.95995 3.52363 6.47995V4.40723H0.850908C0.30909 5.48723 0 6.70904 0 7.99995C0 9.29086 0.30909 10.5127 0.850908 11.5927L3.52363 9.51995Z",
          fill: "#FBBC05"
        }
      ),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99991 3.18181C9.17446 3.18181 10.229 3.58545 11.0581 4.37818L13.3526 2.08363C11.9672 0.792726 10.1563 0 7.99991 0C4.87264 0 2.16719 1.79273 0.85083 4.40727L3.52355 6.47999C4.15264 4.58908 5.91628 3.18181 7.99991 3.18181Z",
          fill: "#EA4335"
        }
      )
    )
  );
});
export {
  GoogleLoginColouredIcon
};
